import type { AxiosInstance } from 'axios';
// import getConfig from 'next/config';
import { cleanTokens } from 'services/auth';
import { refreshAccessTokenByApi } from './refresh-access-token-by-api';

const cleanTokenAndRedirect = () => {
  cleanTokens();
  window.location.href = '/auth';
};

let refreshPromise: Promise<string> | null = null;

export const refreshAccessToken = async (axios: AxiosInstance): Promise<string> => {
  if (refreshPromise) return refreshPromise;

  // eslint-disable-next-line @typescript-eslint/no-misused-promises, no-async-promise-executor
  refreshPromise = new Promise(async (resolve) => {
    try {
      const result = await refreshAccessTokenByApi(axios);
      resolve(result);
    } catch (error) {
      cleanTokenAndRedirect();
      resolve('');
    } finally {
      refreshPromise = null;
    }
  });

  return refreshPromise;
};
